export default __webpack_public_path__ + "static/media/HbHeaderRight1.23691301.svg";